import * as React from 'react';
import { Button } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IDialogFooterProps {
  isDesktop: boolean;
  onClose: () => void;
  onSend: () => void;
  isSubmitDisabled: boolean;
}

export const DialogFooter: React.FC<IDialogFooterProps> = ({ isDesktop, onClose, onSend, isSubmitDisabled }) => {
  return (
    <footer className={styles['container']}>
      <Button
        theme={isDesktop ? 'fill_white_primary' : 'fill_secondary'}
        type="button"
        size={isDesktop ? 'XS' : 'M'}
        onClick={onClose}
        fullWidth={!isDesktop}
        data-testid="leaveContactsDialogDecline"
      >
        {isDesktop ? 'Отменить' : 'Закрыть'}
      </Button>
      <Button
        theme="fill_primary"
        type="submit"
        size={isDesktop ? 'XS' : 'M'}
        onClick={onSend}
        disabled={isSubmitDisabled}
        fullWidth={!isDesktop}
        data-testid="leaveContactsDialogSend"
      >
        Отправить
      </Button>
    </footer>
  );
};
